import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { Button as a } from "../../forms/button/index.js";
import '../../../assets/start.css';const N = "_start_mnwci_1", t = {
  start: N,
  "start--title": "_start--title_mnwci_4",
  "start--content--info--title": "_start--content--info--title_mnwci_7",
  "start--content--info--content": "_start--content--info--content_mnwci_10",
  "start--content--info--action": "_start--content--info--action_mnwci_14",
  "start--content": "_start--content_mnwci_7",
  "start--content--info": "_start--content--info_mnwci_7",
  "start--actions": "_start--actions_mnwci_39"
};
function u({
  gainsButtonContent: c = "Programa de referidos",
  gainsContent: r = "Descubre cómo generar ingresos semanales con Bohiio.",
  gainsTitle: o = "Empieza a generar ganancias",
  mainButtonContent: s = "Empezar ahora",
  mainContent: l = "Explora nuestros servicios y verifica tus propiedades. También puedes contactarnos para diseñar un paquete personalizado para tu empresa.",
  mainTitle: d = "¿Todo listo para empezar?",
  onClickGainsButton: m = () => {
  },
  onClickMainButton: i = () => {
  },
  onClickPlansButton: h = () => {
  },
  plansButtonContent: f = "Ver planes",
  plansContent: _ = "Descubre nuestros planes flexibles y adaptados a tus necesidades en Bohiio.",
  plansTitle: p = "Planes personalizados"
}) {
  return /* @__PURE__ */ e("section", { className: `${t.start}`, children: [
    /* @__PURE__ */ n("h2", { className: `${t["start--title"]}`, children: d }),
    /* @__PURE__ */ e("div", { className: `${t["start--content"]}`, children: [
      /* @__PURE__ */ e("article", { className: `${t["start--content--info"]}`, children: [
        l,
        /* @__PURE__ */ n(
          "div",
          {
            className: `${t["start--actions"]} md:b-hidden b-block b-mt-6`,
            children: /* @__PURE__ */ n(a, { className: "md:b-max-w-52", onClick: i, children: s })
          }
        )
      ] }),
      /* @__PURE__ */ e("article", { className: `${t["start--content--info"]}`, children: [
        /* @__PURE__ */ n("h4", { className: `${t["start--content--info--title"]}`, children: p }),
        /* @__PURE__ */ n("div", { className: `${t["start--content--info--content"]}`, children: _ }),
        /* @__PURE__ */ n("div", { className: `${t["start--content--info--action"]}`, children: /* @__PURE__ */ n(a, { styleType: "link", onClick: h, children: f }) })
      ] }),
      /* @__PURE__ */ e("article", { className: `${t["start--content--info"]}`, children: [
        /* @__PURE__ */ n("h4", { className: `${t["start--content--info--title"]}`, children: o }),
        /* @__PURE__ */ n("div", { className: `${t["start--content--info--content"]}`, children: r }),
        /* @__PURE__ */ n("div", { className: `${t["start--content--info--action"]}`, children: /* @__PURE__ */ n(a, { styleType: "link", onClick: m, children: c }) })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: `${t["start--actions"]} b-hidden md:b-block`, children: /* @__PURE__ */ n(a, { className: "md:b-max-w-52", onClick: i, children: s }) })
  ] });
}
export {
  u as default
};
